export default __webpack_public_path__ + "static/Theinhardt-Regular-subset-62fa7514c4959b6f5c44e7eafcd05287.woff2";